import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const EmotaLogo = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(base: {eq: "emota.png"}, relativeDirectory: {eq: "footer"}) {
        childImageSharp {
          fixed(height: 60) {
            originalName
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return <Img fixed={data.placeholderImage.childImageSharp.fixed} />
}

export default EmotaLogo
